export const PRIVACY_POLICY_LAST_UPDATED = "28 July 2026";

export const PRIVACY_POLICY_CHAT_SUMMARY =
  "Joz MAXX may process the questions, voice transcripts, and interaction context you provide to operate the app and generate responses. Some requests may use third-party AI infrastructure. Do not submit confidential information unless you are comfortable with it being processed. For privacy questions, contact joz@meetjoz.com.";

export const PRIVACY_POLICY_SECTIONS = [
  {
    title: "What Joz MAXX processes",
    paragraphs: [
      "Joz MAXX may process the questions, voice transcripts, and interaction context that you provide while using the app. The app uses this information to operate the experience and generate responses.",
    ],
  },
  {
    title: "How information is used",
    paragraphs: [
      "Information is used to route requests, maintain the current interaction, improve reliability, and provide relevant Joz MAXX responses. Do not submit confidential information unless you are comfortable with it being processed for these purposes.",
    ],
  },
  {
    title: "Third-party processing",
    paragraphs: [
      "Some requests may be processed by infrastructure and AI service providers used to deliver the app. These providers receive only the information needed to provide the requested service and are subject to their own policies.",
    ],
  },
  {
    title: "Retention and control",
    paragraphs: [
      "Retention depends on the feature and the service configuration. You can stop using voice interaction at any time and close the Joz MAXX panel. For privacy questions about this app, contact joz@meetjoz.com.",
    ],
  },
];

export const AI_OVERVIEW_LAST_REVIEWED = "26 July 2026";

export const AI_OVERVIEW_SECTIONS = [
  {
    title: "What this system does",
    paragraphs: [
      "Joz MAXX explains Joz's work and helps frame organizational AI, data, governance, oversight, and adoption problems.",
    ],
  },
  {
    title: "What it must not do",
    paragraphs: [
      "It is not intended to make decisions about a person's hiring, employment, pay, promotion, dismissal, credit, insurance, healthcare, education, benefits, immigration, law-enforcement status, or biometric or emotional state.",
      "Do not treat a confidence score as proof. Do not use an output as the sole basis for a consequential decision.",
    ],
  },
  {
    title: "Human oversight and the EU AI Act",
    paragraphs: [
      "Joz MAXX is designed as an informational and decision-support experience. A person remains responsible for checking outputs, supplying context, making consequential decisions, and taking action.",
      "This overview is product information, not a legal determination or compliance certification. Assess any deployment against the EU AI Act and other applicable requirements before using it in a regulated or high-impact context.",
    ],
  },
];

export const TERMS_SECTIONS = [
  {
    title: "Use of the experience",
    paragraphs: [
      "Use Joz MAXX as an exploratory and informational tool. You are responsible for reviewing outputs and deciding whether they are appropriate for your context.",
    ],
  },
  {
    title: "No guarantee of accuracy",
    paragraphs: [
      "Joz MAXX can make mistakes, omit relevant context, or produce incomplete answers. Verify important information with authoritative sources and qualified professionals.",
    ],
  },
  {
    title: "Contact",
    paragraphs: [
      "Questions about the experience, privacy, or responsible use can be sent to joz@meetjoz.com.",
    ],
  },
];
